import BenchlingConfig from 'BenchlingConfig';

/**
 * Whether MCP / AI Connectors UI should be available. Both Deep Research (Ask) and
 * Assistant use MCP; gate on either feature flag.
 */
export function isMcpAiConnectorsFeatureEnabled(): boolean {
  return BenchlingConfig.LLM_ENABLE_AI_DEEP_RESEARCH || BenchlingConfig.LLM_ENABLE_ASSISTANT_AGENT;
}
